export default __webpack_public_path__ + "static/media/bv.be66462d.svg";